import { StepsComponent } from "../../components/UserInterface/StepsComponent";
import { DataTtdElektronik } from "../../data/DataTtdElektronik";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import {
  ttdElektronikBreadcrumb,
  defBreadcrumb
} from "../../data/DataBreadcrumb";
import NextHead from "../../components/Seo/NextHead";
import { tandaTanganMeta } from "../../data/DataMetatags";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import howToCz from "../../../public/static/images/png/howToCZ.png";
import Description from "../../components/UserInterface/Description";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";

const TtdElektronik = (props) => {
  const { breadcrumb, path, title, description, howTo } = props;

  return (
    <Layout height="auto">
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent
        items={ttdElektronikBreadcrumb}
      ></BreadcrumbComponent>
      <HeadingComponent headingText="Tanda Tangan Elektronik"></HeadingComponent>
      <LayoutCenter>
        <Description
          font="Roboto"
          text={`<span style="color:var(--color-red)">Tanda Tangan Elektronik Home Credit</span> adalah portal tempat kamu melakukan Tanda Tangan Elektronik Kontrak Pembiayaan kamu secara lebih mudah dan praktis. Semua dalam waktu <span style="color:var(--color-red)">sekitar 5 menit</span>!`}
        ></Description>
      </LayoutCenter>
      <StepsComponent
        img={howToCz}
        title={howTo.title}
        steps={howTo.steps}
      ></StepsComponent>
      <LayoutCenter>
        <a href="https://clientzone.homecredit.co.id" target="_blank">
          <button className="button-cz">Lihat Tanda Tangan Elektronik</button>
        </a>
      </LayoutCenter>
      <style jsx>{`
        .button-cz {
          cursor: pointer;
          height: 40px;
          width: auto;
          font-size: 14px;
          color: var(--color-white);
          font-weight: bold;
          background-color: var(--color-red);
          display: flex;
          justify-content: center;
          align-items: center;
          align-self: center;
          border-radius: 10px;
          border: none;
          padding: 0 20px;
        }
        @media only screen and (max-width: 730px) {
          .button-cz {
            margin-bottom: 40px;
          }
        }
      `}</style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = tandaTanganMeta;
  const { howTo } = DataTtdElektronik;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + path,
        name: title
      }
    }
  ];
  return { props: { breadcrumb, path, title, description, howTo } };
};

export default TtdElektronik;
